// Type of action for tracking ad interactions
export const SAVE_AD_INTERACTION = 'SAVE_AD_INTERACTION';